import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import {
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ITrackerHistoryChangeItemResponse } from '../types';
import { TRACKER_HISTORY_CHANGES_ITEM_API_URL, TRACKER_HISTORY_CHANGES_ITEM_QUERY } from '../constants';

export default function useTrackerHistoryChangesItemQuery(id: Ref<number>, merchantId: Ref<number>): IContextQueryResult<
  ITrackerHistoryChangeItemResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ITrackerHistoryChangeItemResponse>({
    queryKey: [TRACKER_HISTORY_CHANGES_ITEM_QUERY, id],
    queryFn: ({ signal }) => fetchGet<ITrackerHistoryChangeItemResponse>(
      TRACKER_HISTORY_CHANGES_ITEM_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          itemId: id.value,
        },
        queryParams: { merchant: merchantId.value },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
